export default "__VITE_ASSET__DffVWaKf__"